import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";
import { createInventoryHealthMatrix } from "../../utils/inventory_health_matrix";
import { useInventoryHealthCellExplanation } from "../inventory_health/use_inventory_health_cell_explanation";

export const RawInventoryHealthContainer = () => {
  const { cellExplanation, cellExplanationEnabled, onRenderedSourceChange } =
    useInventoryHealthCellExplanation("raw");
  // Customer-specific date hierarchy configurations
  const dateHierarchyColumnFilter = {
    week: "week",
    month: "month",
    day: "day",
  };

  // Hardcoded measure options for the dropdown
  const measureColumnFilter = (params: DatePivotParams) => {
    const dateHierarchy =
      params.dateHierarchy.charAt(0).toUpperCase() +
      params.dateHierarchy.slice(1) +
      "s";
    return {
      "Purchase Order To Place": "Purchase Order To Place",
      "raw purchase need": "Raw Purchase Need",
      "Starting Inventory On Hand": "Starting Inventory On Hand",
      "Forecasted Sales": "Forecasted Sales",
      "purchase order arrivals": "PO Arrivals",
      "Ending Inventory On Hand": "Ending Inventory On Hand",
      "Unfulfilled Demand": "Unfulfilled Demand",
      [`Target ${dateHierarchy} of Supply`]: `Target ${dateHierarchy} of Supply`,
      [`Starting ${dateHierarchy} of Supply`]: `Starting ${dateHierarchy} of Supply`,
      [`Ending ${dateHierarchy} of Supply`]: `Ending ${dateHierarchy} of Supply`,
      "In Stock Rate": "In Stock Rate",
    };
  };

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test",
        transformId: "raw_inventory_health",
        folder: "outputs",
        title: "Inventory Health",
        viewContextSurfaceId: "inventory-health",
        dateHierarchyColumnFilter,
        excludedSegmentationsFilter: [],
        measureColumnFilter,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.EnableChartView,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createInventoryHealthMatrix,
        chunkedMatrixTransformId: "raw_inventory_health_matrix",
        excludeDetailRows: true,
        // Same PO measures as the other Inventory Health routes — the
        // raw_inventory_health transform emits "purchase order arrivals" with
        // "open"/"simulated" breakdown rows directly beneath it, plus
        // "purchase order to place" — and the popover reads po_plan_edit /
        // purchase_order_plan, not this route's dataset, so it applies here
        // unchanged.
        //
        // Note: every popover cell is gated on row["sku"], which only exists
        // when "sku" is a requested segmentation — and this route's
        // defaultConfig is segments: ["location"] (unlike the other three IH
        // routes, which default to ["sku", "location"]). So this popover does
        // not appear until the user adds SKU to "Segment by". Left as-is
        // deliberately: the location-grain landing view is the customer's
        // default, not a bug.
        enablePoCellPopover: true,
        enableForecastedSalesPopover: true,
        cellExplanation,
        cellExplanationEnabled,
        onRenderedSourceChange,
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
